import React from 'react';
import {connect} from "react-redux";
import Popup from "../../../parts/Popup";
import CommonTab from "../../../parts/CommonTabClass";

class TenderTypesPurposeComponent extends CommonTab {
    state = {
        tenderPurpose: this.props.tenderPurpose,
        errors: [],
        validateFields: [
            'tenderpurposename',
            'tenderpurposenameeng'
        ]
    };

    changeState(name, e) {
        let temp = this.state.tenderPurpose;
        temp[name] = e.value;
        this.setState({tenderPurpose: temp});
    }

    render() {
        let {tenderPurpose, errors, validateFields} = this.state;
        let {close} = this.props;
        return (
            <Popup openClose={close}>
                <div className={'popup-content-types'}>
                    <form onSubmit={event => {
                        event.preventDefault();
                        this.formValidation(tenderPurpose, validateFields);
                    }}>
                        <h2>{this.props.button} Tender Purpose</h2>
                        <table className={'table table-striped'} align={'right'}>
                            <tbody>
                            <tr>
                                <td>Tender Purpose Name :</td>
                                <td className={errors.indexOf('tenderpurposename') !== -1 ? 'error' : ''}>
                                    <input
                                        type={'text'}
                                        value={tenderPurpose.tenderpurposename}
                                        onChange={(e) => {
                                            this.changeState('tenderpurposename', e.target);
                                        }}
                                    />
                                    {errors.indexOf('tenderpurposename') !== -1 ? <span className="errorText">Please set Tender Purpose Name</span> : '' }
                                </td>
                            </tr>
                            <tr>
                                <td>Tender Purpose Name Eng :</td>
                                <td className={errors.indexOf('tenderpurposenameeng') !== -1 ? 'error' : ''}>
                                    <input
                                        type={'text'}
                                        value={tenderPurpose.tenderpurposenameeng}
                                        onChange={(e) => {
                                            this.changeState('tenderpurposenameeng', e.target);
                                        }}
                                    />
                                    {errors.indexOf('tenderpurposenameeng') !== -1 ? <span className="errorText">Please set Tender Purpose Name Eng</span> : '' }
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <input type={"submit"} className={"btn btn-primary"} value={this.props.button}/>
                    </form>
                </div>
            </Popup>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    let content = {};
    state.tendersPurposes.map((item) => {
        if (item.tenderpurposeid == ownProps.id) {
            content = item;
        }
    });
    return {
        tenderPurpose: Object.assign({}, content)
    }
};

const TenderTypesPurpose = connect(mapStateToProps)(TenderTypesPurposeComponent);

export default TenderTypesPurpose;